import script from "./DiversosView.vue?vue&type=script&setup=true&lang=js"
export * from "./DiversosView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__